module.exports = __webpack_public_path__ + "../resources/images/illustration_search-847f5176a9d7da8f48635b619938ba2e.svg";